import { app } from '../../api/app';
import { IframeWindow } from '.';

export class App implements app.Api {
  constructor(private iframe: IframeWindow) {}

  openApp(request: app.OpenAppRequest): void {
    this.iframe.postMessage({
      command: 'app.openApp',
      args: request,
    });
  }

  openLegalGuide(request: app.OpenLegalGuideRequest): void {
    this.iframe.postMessage({
      command: 'app.openLegalGuide',
      args: request,
    });
  }
}
